import React, { useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom';

const UniversalSearchBar = () => {
    const [query, setQuery] = useState('');
    const [suggestions, setSuggestions] = useState([]);
    const inputRef = useRef();
    const navigate = useNavigate();

    const searchItems = [
        { id: 1, title: "Dashboard", path: "/" },
        { id: 2, title: "Controller", path: "/controller" },
        { id: 3, title: "Profile", path: "/profile" },
        { id: 4, title: "Notification", path: "/notification" },
        { id: 5, title: "Logout", path: "/Logout" },
        { id: 6, title: "Native Ads", path: "/manage/ads/nativeAds/add" },
        { id: 7, title: "Fullscreen Ads", path: "/manage/ads/fullScreenAds/add" },
        { id: 8, title: "Banner Ads", path: "/manage/ads/bannerAds/add" },
        { id: 9, title: "Open Ads", path: "/manage/ads/openAds/add" },
        { id: 10, title: "Reward Ads", path: "/manage/ads/rewardAds/add" },
        { id: 11, title: "InHouse Ads", path: "/manage/ads/inHouseAds/add" },
        { id: 12, title: "Edit InHouse Ads", path: "/manage/ads/inHouseAds/edit/:id" },
        { id: 13, title: "Banner", path: "/manage/banner" },
        { id: 14, title: "Views Dashboard", path: "/views/dashboard/:id" },
        { id: 15, title: "AI Model", path: "/manage/aiModel" },
        { id: 16, title: "List", path: "/manage/list" },
        { id: 17, title: "Category", path: "/manage/category" },
        { id: 18, title: "UI Intro Screen", path: "/manage/UI/introscreen" },
        { id: 19, title: "Policy", path: "/manage/policy" },
        { id: 20, title: "Guide Video", path: "/guide/video" },
        // iOS Ads
        { id: 21, title: "iOS Native Ads", path: "/manage/ads/ios/nativeAds/add" },
        { id: 22, title: "iOS FullScreen Ads", path: "/manage/ads/ios/fullScreenAds/add" },
        { id: 23, title: "iOS Banner Ads", path: "/manage/ads/ios/bannerAds/add" },
        { id: 24, title: "iOS Open Ads", path: "/manage/ads/ios/openAds/add" },
        { id: 25, title: "iOS Reward Ads", path: "/manage/ads/ios/rewardAds/add" },

        { id: 26, title: "Story", path: "/manage/story" },
    ];


    const handleSearch = (e) => {
        const value = e.target.value;
        setQuery(value);
        if (!value) return setSuggestions([]);

        const filtered = searchItems.filter(item =>
            item.title.toLowerCase().includes(value.toLowerCase())
        );
        setSuggestions(filtered.slice(0, 5));
    };

    const handleSelect = (path) => {
        navigate(path);
        setQuery('');
        setSuggestions([]);
    };

    return (
        <div className="relative mx-4 w-full max-w-xs hidden md:block">
            <input
                ref={inputRef}
                type="text"
                value={query}
                onChange={handleSearch}
                placeholder="Search..."
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-main-blue"
            />
            {query && suggestions.length > 0 && (
                <ul className="absolute top-full left-0 right-0 bg-white shadow-lg border rounded-md mt-1 z-50">
                    {suggestions.map((item) => (
                        <li
                            key={item.id}
                            className="px-3 py-2 cursor-pointer hover:bg-gray-100"
                            onClick={() => handleSelect(item.path)}
                        >
                            {item.title}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}

export default UniversalSearchBar